export default __webpack_public_path__ + "img/d78ca09d2194367717b91b126a71aa85.svg";